// Onboarding State
        let currentStep = 1;
        const totalSteps = 14;
        const userData = {};
        
        // Product IDs (diese müssen mit Ihren Shopify-Produkt-IDs übereinstimmen)
        const BASIC_PRODUCT_ID = '53004000919875';
        const PREMIUM_PRODUCT_ID = '53007227322691';        // Initialize
        document.addEventListener('DOMContentLoaded', function() {
            initializeOnboarding();
        });        // Initialize onboarding with authentication check
        async function initializeOnboarding() {
            try {
                // Check if user is logged in
                const customerId = getShopifyCustomerId();
                
                console.log('Customer ID detected:', customerId);
                
                if (!customerId) {
                    // Show login required section instead of redirecting
                    showLoginRequired();
                    return;
                }

                // Hide login section and show onboarding
                hideLoginRequired();
                
                // Check onboarding status and redirect accordingly
                await checkOnboardingStatusAndRedirect(customerId);
                
            } catch (error) {
                console.error('Fehler beim Initialisieren des Onboardings:', error);
                // Start fresh onboarding on error
                startFreshOnboarding();
            }
        }

        // Show login required section
        function showLoginRequired() {
            const loginSection = document.getElementById('loginRequiredSection');
            const onboardingContent = document.getElementById('onboardingContent');
            
            if (loginSection && onboardingContent) {
                loginSection.style.display = 'flex';
                onboardingContent.style.display = 'none';
            }
            
            console.log('Login erforderlich - Benutzer ist nicht angemeldet');
        }

        // Hide login required section
        function hideLoginRequired() {
            const loginSection = document.getElementById('loginRequiredSection');
            const onboardingContent = document.getElementById('onboardingContent');
            
            if (loginSection && onboardingContent) {
                loginSection.style.display = 'none';
                onboardingContent.style.display = 'flex';
                onboardingContent.style.flexDirection = 'column';
            }
        }        // Get Shopify customer ID with improved detection
        function getShopifyCustomerId() {
            // Method 1: Check global customer object (from Liquid)
            if (window.customer && window.customer.id) {
                return window.customer.id;
            }
            
            // Method 2: Check Shopify Analytics
            if (window.ShopifyAnalytics?.meta?.page?.customerId) {
                return window.ShopifyAnalytics.meta.page.customerId;
            }
            
            // Method 3: Check global Shopify object
            if (window.Shopify?.customer?.id) {
                return window.Shopify.customer.id;
            }
            
            // Method 4: Check meta tags
            const customerId = getCustomerIdFromMeta();
            if (customerId) {
                return customerId;
            }
            
            // Method 5: Check if customer object exists in liquid template context
            if (typeof customer !== 'undefined' && customer && customer.id) {
                return customer.id;
            }
            
            return null;
        }

        // Get customer ID from meta tags
        function getCustomerIdFromMeta() {
            const metaTag = document.querySelector('meta[name="customer-id"]');
            return metaTag ? metaTag.getAttribute('content') : null;
        }        // Redirect to login page
        function redirectToLogin() {
            const returnUrl = encodeURIComponent(window.location.pathname + '?login_success=true');
            // Use new customer authentication system for modern Shopify accounts
            if (window.shop && window.shop.permanent_domain) {
                window.location.href = `https://${window.shop.permanent_domain}/customer_authentication/login?return_to=${returnUrl}`;
            } else if (window.Shopify?.shop?.permanent_domain) {
                window.location.href = `https://${window.Shopify.shop.permanent_domain}/customer_authentication/login?return_to=${returnUrl}`;
            } else {
                // Fallback for older systems
                window.location.href = '/account/login?return_url=' + encodeURIComponent(window.location.pathname);
            }
        }        // Check onboarding status and redirect accordingly
        async function checkOnboardingStatusAndRedirect(customerId) {
            try {
                const response = await fetch(`https://body-planet-fitness-programm.vercel.app/api/onboarding?customerId=${customerId}`);
                const statusData = await response.json();

                if (statusData.has_access && statusData.access_valid) {
                    // User has purchased and has valid access - redirect to dashboard
                    window.location.href = '/pages/fitness-dashboard';
                    return;
                }

                if (statusData.onboarding_complete) {
                    // Onboarding completed but no purchase - show summary
                    await showOnboardingSummary(customerId);
                    return;
                }

                if (statusData.last_step && statusData.last_step > 1) {
                    // Resume from where user left off
                    resumeOnboarding(statusData.last_step, statusData.saved_data);
                    return;
                }

                // Start fresh onboarding
                startFreshOnboarding();

            } catch (error) {
                console.error('Fehler beim Prüfen des Onboarding-Status:', error);
                startFreshOnboarding();
            }
        }        // Show onboarding summary for completed users
        async function showOnboardingSummary(customerId) {
            try {
                const response = await fetch(`https://body-planet-fitness-programm.vercel.app/api/onboarding?customerId=${customerId}`);
                const data = await response.json();
                
                displayOnboardingSummary(data);
            } catch (error) {
                console.error('Fehler beim Laden der Onboarding-Zusammenfassung:', error);
                startFreshOnboarding();
            }
        }

        // Resume onboarding from specific step
        function resumeOnboarding(step, savedData) {
            currentStep = step;
            
            // Restore saved data
            if (savedData) {
                Object.assign(userData, savedData);
                restoreFormValues();
            }
            
            // Show welcome back message
            showWelcomeBackMessage();
            
            // Update UI to show current step
            updateUI();
        }

        // Start fresh onboarding
        function startFreshOnboarding() {
            currentStep = 1;
            userData = {};
            updateUI();
            
            // Set focus on first input if exists
            const firstInput = document.querySelector('.step-content.active input, .step-content.active select');
            if (firstInput) {
                firstInput.focus();
            }
        }

        // Navigation Functions
        function nextStep() {
            if (!validateCurrentStep()) {
                return;
            }
            
            saveCurrentStepData();
            
            if (currentStep < totalSteps) {
                currentStep++;
                updateUI();
            }
        }

        function previousStep() {
            if (currentStep > 1) {
                currentStep--;
                updateUI();
            }
        }

        function updateUI() {
            // Update progress
            const progress = (currentStep / totalSteps) * 100;
            document.getElementById('progressFill').style.width = progress + '%';
            document.getElementById('stepCounter').textContent = `Schritt ${currentStep} von ${totalSteps}`;
            
            // Update header title
            const titles = {
                1: "Willkommen bei BodyPlanet",
                2: "Persönliche Daten",
                3: "Dein Alter",
                4: "Deine Ziele",
                5: "Aktuelles Gewicht",
                6: "Zielgewicht",
                7: "Körpergröße",
                8: "Trainingserfahrung",
                9: "Aktivitätslevel",
                10: "Trainingsfrequenz",
                11: "Ernährung",
                12: "Allergien",
                13: "Dein Programm",
                14: "Geschafft!"
            };
            document.getElementById('headerTitle').textContent = titles[currentStep];
            
            // Show/hide steps
            document.querySelectorAll('.step-content').forEach(step => {
                step.classList.remove('active');
            });
            document.querySelector(`[data-step="${currentStep}"]`).classList.add('active');
            
            // Update navigation buttons
            const prevButton = document.getElementById('prevButton');
            const nextButton = document.getElementById('nextButton');
            const backButton = document.getElementById('backButton');
            
            prevButton.style.display = currentStep > 1 ? 'block' : 'none';
            backButton.style.display = currentStep > 1 ? 'flex' : 'none';
            
            if (currentStep === totalSteps) {
                nextButton.textContent = 'Zum Checkout';
                nextButton.onclick = proceedToCheckout;
            } else {
                nextButton.textContent = 'Weiter';
                nextButton.onclick = nextStep;
            }
            
            // Auto-focus first input
            setTimeout(() => {
                const activeStep = document.querySelector('.step-content.active');
                const firstInput = activeStep.querySelector('input:not([type="hidden"]), select, textarea');
                if (firstInput && currentStep > 1) {
                    firstInput.focus();
                }
            }, 300);
        }

        function validateCurrentStep() {
            const activeStep = document.querySelector('.step-content.active');
            
            switch(currentStep) {
                case 2:
                    const firstName = document.getElementById('firstName').value.trim();
                    const gender = userData.gender;
                    if (!firstName || !gender) {
                        alert('Bitte fülle alle Felder aus.');
                        return false;
                    }
                    break;
                    
                case 3:
                    const age = document.getElementById('age').value;
                    if (!age || age < 16 || age > 80) {
                        alert('Bitte gib ein gültiges Alter ein (16-80 Jahre).');
                        return false;
                    }
                    break;
                    
                case 4:
                    if (!userData.goal) {
                        alert('Bitte wähle dein Hauptziel aus.');
                        return false;
                    }
                    break;
                    
                case 5:
                    const currentWeight = document.getElementById('currentWeight').value;
                    if (!currentWeight || currentWeight < 40 || currentWeight > 200) {
                        alert('Bitte gib ein gültiges Gewicht ein (40-200 kg).');
                        return false;
                    }
                    break;
                    
                case 7:
                    const height = document.getElementById('height').value;
                    if (!height || height < 140 || height > 220) {
                        alert('Bitte gib eine gültige Größe ein (140-220 cm).');
                        return false;
                    }
                    break;
                    
                case 8:
                    if (!userData.level) {
                        alert('Bitte wähle dein Erfahrungslevel aus.');
                        return false;
                    }
                    break;
                    
                case 9:
                    if (!userData.activityLevel) {
                        alert('Bitte wähle dein Aktivitätslevel aus.');
                        return false;
                    }
                    break;
                    
                case 10:
                    if (!userData.trainingDays) {
                        alert('Bitte wähle deine gewünschte Trainingsfrequenz aus.');
                        return false;
                    }
                    break;
                    
                case 11:
                    if (!userData.dietaryPreferences) {
                        alert('Bitte wähle deine Ernährungsgewohnheiten aus.');
                        return false;
                    }
                    break;
                    
                case 13:
                    if (!userData.package) {
                        alert('Bitte wähle ein Programm aus.');
                        return false;
                    }
                    break;
            }
            
            return true;
        }

        function saveCurrentStepData() {
            switch(currentStep) {
                case 2:
                    userData.firstName = document.getElementById('firstName').value.trim();
                    break;
                case 3:
                    userData.age = document.getElementById('age').value;
                    break;
                case 5:
                    userData.currentWeight = document.getElementById('currentWeight').value;
                    break;
                case 6:
                    userData.targetWeight = document.getElementById('targetWeight').value;
                    break;
                case 7:
                    userData.height = document.getElementById('height').value;
                    break;
                case 12:
                    userData.allergies = document.getElementById('allergies').value;
                    break;
            }
        }

        // Choice Selection
        function selectChoice(element, dataKey) {
            // Remove selection from siblings
            element.parentNode.querySelectorAll('.choice-card').forEach(card => {
                card.classList.remove('selected');
            });
            
            // Add selection to clicked element
            element.classList.add('selected');
            
            // Save data
            userData[dataKey] = element.getAttribute('data-value');
        }

        // Package Selection
        function selectPackage(element) {
            // Remove selection from siblings
            element.parentNode.querySelectorAll('.package-card').forEach(card => {
                card.classList.remove('selected');
            });
            
            // Add selection to clicked element
            element.classList.add('selected');
            
            // Save package selection
            userData.package = element.getAttribute('data-package');
        }

        // Proceed to Checkout
        function proceedToCheckout() {
            if (!validateCurrentStep()) {
                return;
            }
            
            saveCurrentStepData();
            
            // Fill checkout form with collected data
            document.getElementById('productId').value = userData.package === 'premium' ? PREMIUM_PRODUCT_ID : BASIC_PRODUCT_ID;
            document.getElementById('checkout_firstName').value = userData.firstName || '';
            document.getElementById('checkout_gender').value = userData.gender || '';
            document.getElementById('checkout_age').value = userData.age || '';
            document.getElementById('checkout_goal').value = userData.goal || '';
            document.getElementById('checkout_currentWeight').value = userData.currentWeight || '';
            document.getElementById('checkout_targetWeight').value = userData.targetWeight || '';
            document.getElementById('checkout_height').value = userData.height || '';
            document.getElementById('checkout_level').value = userData.level || '';
            document.getElementById('checkout_activityLevel').value = userData.activityLevel || '';
            document.getElementById('checkout_trainingDays').value = userData.trainingDays || '';
            document.getElementById('checkout_dietaryPreferences').value = userData.dietaryPreferences || '';
            document.getElementById('checkout_allergies').value = userData.allergies || '';
            document.getElementById('checkout_package').value = userData.package || '';
            
            // Submit form to add to cart
            document.getElementById('checkoutForm').submit();
        }

        // Keyboard Navigation
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                nextStep();
            } else if (e.key === 'Escape' && currentStep > 1) {
                e.preventDefault();
                previousStep();
            }
        });

        // Auto-advance for single-choice questions after selection
        function autoAdvance() {
            setTimeout(() => {
                if (currentStep === 4 || currentStep === 8 || currentStep === 9 || currentStep === 10 || currentStep === 11) {
                    nextStep();
                }
            }, 800);
        }        // Enhanced choice selection with auto-advance
        function selectChoice(element, dataKey) {
            // Remove selection from siblings
            element.parentNode.querySelectorAll('.choice-card').forEach(card => {
                card.classList.remove('selected');
            });
            
            // Add selection to clicked element
            element.classList.add('selected');
            
            // Save data
            userData[dataKey] = element.getAttribute('data-value');
            
            // Save progress to server
            saveProgressToServer();
            
            // Auto-advance for certain steps
            autoAdvance();
        }

        // Welcome back message for returning users
        function showWelcomeBackMessage() {
            const headerTitle = document.getElementById('headerTitle');
            const originalTitle = headerTitle.textContent;
            
            headerTitle.textContent = 'Willkommen zurück! 👋';
            headerTitle.style.color = 'var(--success-color)';
            
            // Show notification
            showNotification('Du kannst dort weitermachen, wo du aufgehört hast!', 'success');
            
            // Reset after 3 seconds
            setTimeout(() => {
                headerTitle.style.color = '';
            }, 3000);
        }

        // Display onboarding summary for completed users
        function displayOnboardingSummary(data) {
            const container = document.querySelector('.onboarding-container');
            
            container.innerHTML = `
                <div class="header">
                    <h1 id="headerTitle">Deine Onboarding-Übersicht 📋</h1>
                    <div class="progress-bar">
                        <div class="progress-fill" style="width: 100%;"></div>
                    </div>
                    <div class="step-counter">Onboarding abgeschlossen</div>
                </div>
                
                <div class="content">
                    <div class="step-content active">
                        <h2 class="step-title">Hier sind deine Angaben</h2>
                        <p class="step-subtitle">Du hast das Onboarding bereits abgeschlossen. Hier ist eine Übersicht deiner Daten:</p>
                        
                        <div style="background: var(--bg-secondary); border-radius: var(--radius-md); padding: var(--spacing-lg); margin-bottom: var(--spacing-lg);">
                            <h3 style="margin-bottom: var(--spacing-md); color: var(--primary-color);">Persönliche Daten</h3>
                            <div style="display: grid; gap: var(--spacing-sm);">
                                <div><strong>Name:</strong> ${data.personal_info?.first_name || 'Nicht angegeben'}</div>
                                <div><strong>Geschlecht:</strong> ${data.personal_info?.gender || 'Nicht angegeben'}</div>
                                <div><strong>Alter:</strong> ${data.personal_info?.age || 'Nicht angegeben'} Jahre</div>
                            </div>
                        </div>
                        
                        <div style="background: var(--bg-secondary); border-radius: var(--radius-md); padding: var(--spacing-lg); margin-bottom: var(--spacing-lg);">
                            <h3 style="margin-bottom: var(--spacing-md); color: var(--primary-color);">Ziele & Training</h3>
                            <div style="display: grid; gap: var(--spacing-sm);">
                                <div><strong>Hauptziel:</strong> ${data.goals?.goal || 'Nicht angegeben'}</div>
                                <div><strong>Erfahrungslevel:</strong> ${data.goals?.level || 'Nicht angegeben'}</div>
                                <div><strong>Trainingstage:</strong> ${data.training?.training_days || 'Nicht angegeben'}</div>
                                <div><strong>Aktivitätslevel:</strong> ${data.training?.activity_level || 'Nicht angegeben'}</div>
                            </div>
                        </div>
                        
                        <div style="background: var(--bg-secondary); border-radius: var(--radius-md); padding: var(--spacing-lg); margin-bottom: var(--spacing-lg);">
                            <h3 style="margin-bottom: var(--spacing-md); color: var(--primary-color);">Körperdaten</h3>
                            <div style="display: grid; gap: var(--spacing-sm);">
                                <div><strong>Aktuelles Gewicht:</strong> ${data.body_data?.current_weight || 'Nicht angegeben'} kg</div>
                                <div><strong>Zielgewicht:</strong> ${data.body_data?.target_weight || 'Nicht angegeben'} kg</div>
                                <div><strong>Größe:</strong> ${data.body_data?.height || 'Nicht angegeben'} cm</div>
                            </div>
                        </div>
                        
                        <div style="background: var(--bg-secondary); border-radius: var(--radius-md); padding: var(--spacing-lg); margin-bottom: var(--spacing-xl);">
                            <h3 style="margin-bottom: var(--spacing-md); color: var(--primary-color);">Ernährung</h3>
                            <div style="display: grid; gap: var(--spacing-sm);">
                                <div><strong>Ernährungsgewohnheiten:</strong> ${data.nutrition?.dietary_preferences || 'Nicht angegeben'}</div>
                                <div><strong>Allergien:</strong> ${data.nutrition?.allergies || 'Keine angegeben'}</div>
                                <div><strong>Tägliche Kalorien:</strong> ${data.nutrition?.daily_calories || 'Nicht berechnet'} kcal</div>
                            </div>
                        </div>
                        
                        <div style="background: linear-gradient(135deg, var(--primary-color), var(--accent-color)); color: white; border-radius: var(--radius-md); padding: var(--spacing-lg); text-align: center; margin-bottom: var(--spacing-lg);">
                            <h3 style="margin-bottom: var(--spacing-sm);">Bereit für dein Programm? 🚀</h3>
                            <p style="margin-bottom: var(--spacing-md); opacity: 0.9;">Wähle jetzt dein Paket und starte deine Transformation!</p>
                        </div>
                    </div>
                    
                    <div class="button-group">
                        <button class="btn btn-secondary" onclick="editOnboarding()" style="flex: 0.4;">
                            Daten bearbeiten
                        </button>
                        <button class="btn btn-primary" onclick="showPackageSelection()" style="flex: 0.6;">
                            Programm auswählen
                        </button>
                    </div>
                </div>
            `;
        }

        // Edit onboarding data
        function editOnboarding() {
            location.reload(); // Restart onboarding
        }

        // Show package selection for completed onboarding
        function showPackageSelection() {
            currentStep = 13; // Go to package selection step
            document.querySelector('.onboarding-container').innerHTML = originalOnboardingHTML;
            updateUI();
        }

        // Restore form values from saved data
        function restoreFormValues() {
            // Restore text inputs
            if (userData.firstName) document.getElementById('firstName').value = userData.firstName;
            if (userData.age) document.getElementById('age').value = userData.age;
            if (userData.currentWeight) document.getElementById('currentWeight').value = userData.currentWeight;
            if (userData.targetWeight) document.getElementById('targetWeight').value = userData.targetWeight;
            if (userData.height) document.getElementById('height').value = userData.height;
            if (userData.allergies) document.getElementById('allergies').value = userData.allergies;
            
            // Restore choice selections
            setTimeout(() => {
                Object.entries(userData).forEach(([key, value]) => {
                    const choiceCard = document.querySelector(`[data-value="${value}"]`);
                    if (choiceCard) {
                        choiceCard.classList.add('selected');
                    }
                });
            }, 100);
        }
        // Save progress to server
        async function saveProgressToServer() {
            const customerId = getShopifyCustomerId();
            if (!customerId) return;
            
            try {
                const response = await fetch(`https://body-planet-fitness-programm.vercel.app/api/onboarding`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        customerId: customerId,
                        currentStep: currentStep,
                        completedSteps: Object.keys(userData),
                        completed: false
                    })
                });
                
                if (response.ok) {
                    console.log('Fortschritt erfolgreich gespeichert');
                } else {
                    console.log('Server-Speicherung fehlgeschlagen, verwende lokalen Speicher');
                    saveProgressLocally();
                }
            } catch (error) {
                console.log('Fortschritt konnte nicht gespeichert werden, verwende lokalen Speicher:', error);
                saveProgressLocally();
            }
        }
        
        // Fallback: Fortschritt lokal speichern
        function saveProgressLocally() {
            try {
                const progressData = {
                    customerId: getShopifyCustomerId(),
                    step: currentStep,
                    data: userData,
                    timestamp: new Date().toISOString()
                };
                localStorage.setItem('bodyplanet_onboarding_progress', JSON.stringify(progressData));
                console.log('Fortschritt lokal gespeichert');
            } catch (error) {
                console.log('Lokale Speicherung fehlgeschlagen:', error);
            }
        }

        // Method to save supplement preferences
        function saveSupplementPreferences(data) {
            const supplementData = {
                supplement_goals: data.goals || [],
                supplement_experience: data.experience || 'beginner',
                supplement_budget: data.budget || 'medium',
                supplement_allergies: data.allergies || [],
                supplement_preferences: data.preferences || []
            };

            // Save to localStorage for immediate use
            localStorage.setItem('bp_supplement_preferences', JSON.stringify(supplementData));

            // Send to backend
            this.sendOnboardingData('supplement_preferences', supplementData);
            
            console.log('Supplement preferences saved:', supplementData);
        }

        // Show notification
        function showNotification(message, type = 'info', duration = 4000) {
            const notification = document.createElement('div');
            notification.style.cssText = `
                position: fixed;
                top: 20px;
                right: 20px;
                background: ${type === 'success' ? 'var(--success-color)' : type === 'error' ? '#dc3545' : 'var(--primary-color)'};
                color: white;
                padding: 16px 24px;
                border-radius: var(--radius-md);
                box-shadow: 0 8px 24px rgba(0,0,0,0.15);
                z-index: 1000;
                font-weight: 500;
                max-width: 300px;
                animation: slideIn 0.3s ease;
                font-size: 14px;
                line-height: 1.4;
            `;
            notification.textContent = message;
            
            document.body.appendChild(notification);
            
            setTimeout(() => {
                notification.style.animation = 'slideOut 0.3s ease forwards';
                setTimeout(() => {
                    if (notification.parentNode) {
                        notification.remove();
                    }
                }, 300);
            }, duration);
        }

        console.log('BodyPlanet Onboarding Flow geladen');